// extracted by mini-css-extract-plugin
module.exports = {"list":"list--1lai8","typesTitle":"typesTitle--2wiEq","itemTitle":"itemTitle--8kshX","title":"title--IlKFL","types":"types--3X6a3","box":"box--3txbW"};